<template>
    <div>
        <div class="flex justify-center m-3 w-full" v-if="loading">
            <spinner />
        </div>
        <template v-else>
            <breadcrumb :links="links" />
            <productInfo
                :product="product"
                :productLinks="productLinks"
                class="px-2 md:pl-16 md:pr-4"
            >
                <template v-if="!user">
                    <div class="flex flex-col self-center">
                        <router-link
                            tag="button"
                            class="btn btn-white py-3 text-xl flex justify-center mt-2"
                            :to="{
                                name: 'login',
                                params: { lastRoute: $route }
                            }"
                        >
                            {{ '「試吓啦」會員登入' }}
                        </router-link>
                        <a
                            href="https://tryhala.com/info/member_enquiry/"
                            target="_blank"
                            class="btn btn-primary py-3 text-xl flex justify-center mt-2"
                        >
                            {{ '我想成為「試吓啦」會員' }}
                        </a>
                    </div>
                </template>
            </productInfo>
        </template>
    </div>
</template>

<script>
import spinner from '@/components/spinner.vue';
import productInfo from '@/components/productInfo.vue';
import breadcrumb from '@/components/breadcrumb.vue';
import { instance } from '@/utils/ajax';

async function getProductByProdId(prodId) {
    try {
        const result = await instance.get(`/api/product/getInfo/${prodId}`);
        return result.data.data.product;
    } catch (e) {
        /*eslint-disable no-console*/
        console.error('error get product by prodId');
    }
    return undefined;
}

export default {
    components: { spinner, productInfo, breadcrumb },
    props: {
        breadcrumbPrependLinks: { type: Array, default: () => [] }
    },
    data() {
        return { loading: true, product: undefined, productLinks: [] };
    },
    async mounted() {
        this.loading = true;
        const product = await getProductByProdId(this.$route.params.prodId);
        if (!product) {
            this.$router.push('/');
            return;
        }
        this.product = product;
        this.productLinks = product.prodLinkList || [];
        this.loading = false;
    },
    computed: {
        links() {
            const link = {
                text: this.$config.showProdName
                    ? this.product.prodName
                    : '產品資料'
            };
            return this.breadcrumbPrependLinks.concat([link]);
        },
        user() {
            return this.$store.state.user;
        }
    }
};
</script>
